import React, { createContext, useReducer } from 'react';
import { cartItemsReducer } from 'reducers/cartReducer';
import {
  ADD_CART_ITEM,
  UPDATE_CART,
  REMOVE_CART_ITEM,
  SUBSCRIPTION_DETAILS_BY_ID,
  REQUEST,
  FAIL,
  SET_ORDER_DETAILS,
  SET_MULTIPLE_CARDS,
  SET_CREDIT_CARD,
  SET_SOURCE_ID,
  IS_FETCHING,
  CHECKOUT_PAYMENT_ERROR,
  SET_PROGRAM_PRODUCTS,
} from 'constants/cartConstants';
import { getSmallerCCimg } from 'components/cart/reviewOrder/PaymentMethod';
import {
  getCCType,
  getFirstNumFromBrand,
} from 'components/payment/PaymentMethodFormBody';

interface CartContextProps {
  state: any;
  cartActions: any;
  dispatch: ({ type }: { type: string }) => void;
}

export const CartContext = createContext({} as CartContextProps);

const checkoutDetails =
  localStorage.getItem('checkoutDetails') &&
  localStorage.getItem('checkoutDetails') !== 'undefined'
    ? JSON.parse(localStorage.getItem('checkoutDetails') || '')
    : {};

const ccFirstNum = checkoutDetails?.paymentSource?.creditCard?.brand
  ? getFirstNumFromBrand(checkoutDetails?.paymentSource?.creditCard?.brand)
  : '';

const programProducts: Array<any> = [];

export const initialState = {
  programProducts,
  cartItems:
    localStorage.getItem('cart') && localStorage.getItem('cart') !== 'undefined'
      ? JSON.parse(localStorage.getItem('cart') || '')
      : [],
  lastItem: null,
  subscriptions: [],
  subscriptionDetails: {},
  loading: true,
  error: false,
  order: checkoutDetails,
  multipleAddresses:
    localStorage.getItem('myAddresses') &&
    localStorage.getItem('myAddresses') !== 'undefined'
      ? JSON.parse(localStorage.getItem('myAddresses') || '')
      : [],
  multipleCards: [],
  cc: {
    firstNum: ccFirstNum,
    lastFourNums: checkoutDetails?.paymentSource?.creditCard?.lastFourDigits,
    exp: `${checkoutDetails?.paymentSource?.creditCard?.expirationMonth}/${checkoutDetails?.paymentSource?.creditCard?.expirationYear}`,
    type: getCCType(ccFirstNum).brand,
    name: checkoutDetails?.paymentSource?.creditCard?.brand,
    image: getSmallerCCimg(getCCType(ccFirstNum).brand),
  },
  paymentSourceId: checkoutDetails?.paymentSource?.paymentSourceId,
  isFetching: false,
  showPaymentError: false,
  paymentErrorMsg: '',
};

export const CartProvider = ({ children }) => {
  const [state, dispatch] = useReducer(cartItemsReducer, initialState);
  const cartActions = {
    addCartItem: item => dispatch({ type: ADD_CART_ITEM, payload: item }),
    updateCart: item => dispatch({ type: UPDATE_CART, payload: item }),
    removeCartItem: sku => dispatch({ type: REMOVE_CART_ITEM, payload: sku }),
    getSubscriptionDetails: async id => {
      try {
        dispatch({ type: REQUEST });
        dispatch({ type: SUBSCRIPTION_DETAILS_BY_ID, payload: id });
      } catch (err) {
        dispatch({ type: FAIL, payload: true });
      }
    },
    setCheckoutDetails: order =>
      dispatch({ type: SET_ORDER_DETAILS, payload: order }),
    setMultipleCards: card =>
      dispatch({ type: SET_MULTIPLE_CARDS, payload: card }),
    setCreditCard: card => dispatch({ type: SET_CREDIT_CARD, payload: card }),
    setSourceId: id => dispatch({ type: SET_SOURCE_ID, payload: id }),
    setIsFetching: bool => dispatch({ type: IS_FETCHING, payload: bool }),
    setCheckoutError: (msg: string | null) =>
      dispatch({ type: CHECKOUT_PAYMENT_ERROR, payload: msg }),
    setProgramProducts: products =>
      dispatch({ type: SET_PROGRAM_PRODUCTS, payload: products }),
  };

  return (
    <CartContext.Provider
      value={{
        state,
        cartActions,
        dispatch,
      }}>
      {children}
    </CartContext.Provider>
  );
};
